import { Builder } from '@builder.io/react';
import { BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES } from '../BuilderComponentsName';
import { S39AdBannerSection } from '../components/interactive-sections/S39AdBanner';
import { getPaddingInputs } from '../utils/builderSharedInputs';

Builder.registerComponent(S39AdBannerSection, {
    name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S39AdBanner,
    friendlyName: 'S39 Ad Banner',
    inputs: [
        {
            name: 'customBackgroundColor',
            type: 'color',
            friendlyName: 'Background Color',
            helperText: 'Background color as hex code (must include # prefix). Default is #D7F2FF.',
            defaultValue: '#D7F2FF',
            required: true,
        },
        {
            name: 'mobileImageSrc',
            type: 'file',
            friendlyName: 'Mobile Image',
            helperText: 'Image source for mobile (100% width, XS-SM breakpoints)',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
            required: true,
            defaultValue:
                'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F98f4b8b979b84057863c2c2fd237fa5d',
        },
        {
            name: 'mobileImageAlt',
            type: 'string',
            friendlyName: 'Mobile Image Alt Text',
            helperText: 'Alt text for mobile image (XS-SM breakpoints)',
            required: true,
            defaultValue: 'Mobile Ad Banner',
        },
        {
            name: 'desktopImageSrc',
            type: 'file',
            friendlyName: 'Desktop Image',
            helperText: 'Image source for desktop (750x525px, MD-XXL breakpoints)',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
            required: true,
            defaultValue:
                'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F5979a39901574310bad6e9ea0db21b8c',
        },
        {
            name: 'desktopImageAlt',
            type: 'string',
            friendlyName: 'Desktop Image Alt Text',
            helperText: 'Alt text for desktop image (MD-XXL breakpoints)',
            required: true,
            defaultValue: 'Desktop Ad Banner',
        },
        {
            name: 'href',
            type: 'string',
            friendlyName: 'Link URL',
            helperText: 'URL to navigate to when clicking the ad banner (opens in new tab)',
            required: true,
            defaultValue: 'https://example.com',
        },
        {
            name: 'loading',
            type: 'string',
            friendlyName: 'Image Loading',
            helperText: 'Image loading behavior (lazy or eager)',
            enum: ['lazy', 'eager'],
            defaultValue: 'lazy',
        },
        ...getPaddingInputs({
            desktopTop: 'none',
            desktopBottom: 'none',
            mobileTop: 'none',
            mobileBottom: 'none',
        }),
    ],
});
